// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingComponent_root_3aEUO","loading":"LoadingComponent_loading_EqT5a"};